module.exports = __webpack_public_path__ + "static/media/tuanjie.bd74c710.png";